import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import 'firebase/storage'
import 'firebase/analytics'

let config = {
  apiKey: "AIzaSyCQIXXmmOhXiWQQOR-2kACI1EhGiIMzB_Q",
  authDomain: "nutrition-outreach.firebaseapp.com",
  projectId: "nutrition-outreach",
  storageBucket: "nutrition-outreach.appspot.com",
  messagingSenderId: "583377894424",
  appId: "1:583377894424:web:2346ca97c5c698b055576d",
  measurementId: "G-H31E3NDHHL"
};

firebase.initializeApp(config)

export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const facebookProvider = new firebase.auth.FacebookAuthProvider()
const analytics = firebase.analytics()
const db = firebase.firestore()
const storage = firebase.storage()

export { db, storage, firebase }
